/** @jsxImportSource @emotion/react */

import React from "react";
import { CardSchema } from "../../../constants/firestore_schema";
import { todayInKorea } from "../../../utils/datetime";
import { CSS_TD } from "../DataExplorerView/shared";
import HashtagTimeSeriesGenerationAnswersForCard from "./HashtagTimeSeriesGenerationAnswersForCard";

export default function HashtagTimeSeriesGenerationAnswers({
  cards
}: {
  cards: CardSchema[];
}) {
  if (!cards) {
    return null;
  }

  return (
    <table>
      <tr>
        <td css={CSS_TD}>날짜</td>
        <td css={CSS_TD}>10대</td>
        <td css={CSS_TD}>20대</td>
        <td css={CSS_TD}>30대</td>
        <td css={CSS_TD}>40대</td>
        <td css={CSS_TD}>50대</td>
        <td css={CSS_TD}>60대 이상</td>
      </tr>
      {cards.map(card => {
        const koreanDate = todayInKorea(card.featuredOnNewsTimelineAt);

        return (
          <tr key={card.id}>
            <td css={CSS_TD}>
              {koreanDate.year +
                "." +
                koreanDate.month +
                "." +
                koreanDate.day +
                "."}
            </td>
            <HashtagTimeSeriesGenerationAnswersForCard cardId={card.id} />
          </tr>
        );
      })}
    </table>
  );
}
